import { ReactElement } from 'react';
import styled from 'styled-components';
import COLORS from '../../colors';

interface SummaryContainerProps {
  children: ReactElement | ReactElement[];
  title: string;
}

const StyledSummaryContainer = styled.div`
  flex: 1;
  width: 100%;
  position: relative;
  border-radius: 12px;
  border: 1px solid ${COLORS.NEUTRAL_700};
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  text-align: justify;
  font-size: 16px;
  color: ${COLORS.NEUTRAL_500};
`;

const SummaryContainer = ({ children, title }: SummaryContainerProps) => {
  return (
    <StyledSummaryContainer>
      <h2>{title}</h2>
      {children}
    </StyledSummaryContainer>
  );
};

export default SummaryContainer;
